<template>
  <div class="case-review-guide">
    <van-popup v-model="visible" :close-on-click-overlay="false">
      <div
        v-if="currentStep"
        class="case-review-guide__highlight"
        :style="highlightStyle"
        @click.stop
      />
      <div
        v-if="currentStep"
        class="case-review-guide__popover"
        :style="popoverStyle"
        @click.stop
      >
        <img
          :src="currentStep.icon"
          alt=""
          :style="{ width: currentStep.iconWidth + 'px' }"
        >
      </div>
      <div v-if="currentStep" class="case-review-guide__btn" @click="next">
        {{ currentStep.step !== '2' ? '下一步' : '我知道了' }}
      </div>
    </van-popup>
  </div>
</template>

<script>
/** 医鉴列表页专用操作指引，仅两步：筛选区 → 完成度 */
export default {
  name: 'CaseReviewGuide',
  data () {
    return {
      visible: false,
      steps: [],
      stepIndex: 0,
    }
  },
  computed: {
    currentStep () {
      return this.steps[this.stepIndex]
    },
    highlightStyle () {
      if (!this.currentStep || !this.currentStep.rect) return {}
      const { top, left, width, height } = this.currentStep.rect
      const expandedWidth = width + 5
      const expandedHeight = height + 5
      return {
        top: `${top - (expandedHeight - height) / 2}px`,
        left: `${left - (expandedWidth - width) / 2}px`,
        width: `${expandedWidth}px`,
        height: `${expandedHeight}px`,
      }
    },
    popoverStyle () {
      if (!this.currentStep || !this.currentStep.rect) return {}
      const { top, left, width, height } = this.currentStep.rect
      const step = this.currentStep.step || '1'
      const style = {}

      switch (step) {
        case '1':
          style.top = `${top + height - 10}px`
          style.left = `${left + width - 40}px`
          break
        case '2':
          style.top = `${top + height - 10}px`
          style.left = `${left - this.currentStep.iconWidth / 2 - 50}px`
          break
      }

      return style
    },
  },
  methods: {
    /** 启动指引，steps: [{ step, selector, icon, iconWidth }] */
    start (steps = []) {
      if (!steps.length) return
      this.steps = steps
      this.stepIndex = 0
      this.visible = true
      this.$nextTick(() => {
        this.updateHighlight()
      })
    },
    updateHighlight () {
      const step = this.currentStep
      if (!step) return
      const el = document.querySelector(step.selector)
      if (el) {
        this.$set(step, 'rect', el.getBoundingClientRect())
      }
    },
    next () {
      if (this.currentStep.step !== '2') {
        this.stepIndex++
        this.$nextTick(() => {
          this.updateHighlight()
        })
      } else {
        this.visible = false
        this.$emit('finish')
      }
    },
  },
}
</script>

<style scoped lang="less">
.case-review-guide {
  &__highlight {
    position: absolute;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
    z-index: 10000;
    border-radius: 10px;
  }

  &__popover {
    position: absolute;
    z-index: 10001;
    pointer-events: none;
  }

  &__btn {
    position: absolute;
    bottom: 20vh;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10002;
    width: 136px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #EB1700;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
}

/deep/ .van-popup {
  background-color: transparent;
  overflow-y: visible;
  z-index: 10008 !important;
  height: 100%;
  width: 100%;
}

/deep/ .van-overlay {
  z-index: 10007 !important;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/GuideCaseReview.vue